import {
  Box,
  Card,
  CardContent,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import { useNonPollingVehicles } from './useNonPollingVehicles';
import { MaterialReactTable } from 'material-react-table';

const summaryColumns = [
  {
    accessorKey: 'twoWeeks',
    header: '2 Weeks - 1 Month',
    muiTableHeadCellProps: {
      align: 'right',
    },
    muiTableBodyCellProps: {
      align: 'right',
    },
    size: 0,
  },
  {
    accessorKey: 'oneMonth',
    header: '1 - 6 Months',
    muiTableHeadCellProps: {
      align: 'right',
    },
    muiTableBodyCellProps: {
      align: 'right',
    },
    size: 0,
  },
  {
    accessorKey: 'sixMonths',
    header: '> 6 Months',
    muiTableHeadCellProps: {
      align: 'right',
    },
    muiTableBodyCellProps: {
      align: 'right',
    },
    size: 0,
  },
];

const columns = [
  {
    accessorKey: 'registrationNumber',
    header: 'Registration',
    size: 0,
    Cell: ({ row: { original } }) => (
      <Tooltip
        title={
          <table>
            <tbody>
              <tr>
                <td>Fleet Number</td>
                <td>{original.fleetNumber}</td>
              </tr>
              <tr>
                <td>VIN</td>
                <td>{original.identificationNumber}</td>
              </tr>
            </tbody>
          </table>
        }
        placement="right"
      >
        <Box component="span">{original.registrationNumber}</Box>
      </Tooltip>
    ),
  },
  {
    accessorKey: 'homeStation',
    header: 'Home Station',
    size: 0,
  },
  {
    accessorKey: 'lastPollTime',
    header: 'Last Poll Time',
    size: 0,
    Cell: ({ cell }) => format(cell.getValue(), 'dd/MM/yyyy HH:mm:ss'),
  },
];

export function NonPollingVehiclesCard({ groupCode }) {
  const {
    query: {
      data: { twoWeeks, oneMonth, sixMonths, vehicles },
    },
  } = useNonPollingVehicles(groupCode);

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle2" gutterBottom color="textSecondary">
          Non-polling Vehicles
        </Typography>
        <Stack spacing={2}>
          <MaterialReactTable
            data={[{ twoWeeks, oneMonth, sixMonths }]}
            columns={summaryColumns}
            initialState={{
              density: 'compact',
            }}
            enableTopToolbar={false}
            enableBottomToolbar={false}
            muiTableBodyRowProps={{
              sx: { '&:last-child td, &:last-child th': { border: 0 } },
            }}
          />
          <MaterialReactTable
            data={vehicles}
            columns={columns}
            initialState={{
              density: 'compact',
              pagination: {
                pageIndex: 0,
                pageSize: 5,
              },
            }}
            enableTopToolbar={false}
            enableBottomToolbar={true}
            enablePagination={true}
            enableColumnActions={false}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
